import React, { useContext } from "react";
import { AreaOfInterestType, TScreen } from "api/type";

// Import Contexts
import ScreenContext from "contexts/screen";

// Import Components
import {
  NormalText,
  PrimaryButton,
  TitleBar,
  SelectAreasOfInterest,
} from "components/index";

import { SessionContext } from "contexts";

type ScreenSelectAreasOfInterestProps = {
  selectedAreaOfInterest: AreaOfInterestType[];
  handleSaveSelectedAreaOfInterest: (
    areasOfInterest: AreaOfInterestType[],
  ) => void;
};

const ScreenSelectAreasOfInterest: React.FC<
  ScreenSelectAreasOfInterestProps
> = ({ selectedAreaOfInterest, handleSaveSelectedAreaOfInterest }) => {
  // Context
  const session = useContext(SessionContext);
  const setScreen = useContext(ScreenContext)[1];

  if (!session) return null;

  const handleClickContinue = () => {
    setScreen(TScreen.SELECT_PROCEDURE_SCREEN);
  };

  return (
    <div className="screen-container">
      <TitleBar name={"Pick a region to visualize"} onClickBackButton={null} />
      <NormalText
        textContent={"We’ll show you how you’d look with a procedure"}
      />
      <SelectAreasOfInterest
        initialSelectedAreasOfInterest={selectedAreaOfInterest}
        handleSaveSelectedAreaOfInterest={(areasOfInterest) => {
          handleSaveSelectedAreaOfInterest(areasOfInterest);
        }}
      />
      <PrimaryButton
        text={"Continue"}
        disabled={selectedAreaOfInterest.length === 0}
        fullWidth
        onClick={() => handleClickContinue()}
      />
    </div>
  );
};

export default ScreenSelectAreasOfInterest;
